// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__2nCYa","error":"InputSecondary_error__2Ecei","disabled":"InputSecondary_disabled__30Kea"};